// extracted by mini-css-extract-plugin
export default {"nutrientTable":"Ah2GKLTfB2XHJEY3TiNb"};